<div class="categories-navigation" #categoriesNavigation id="navigation">
   <!-- Поиск — в меню от MenuSearchService.MIN_ITEMS позиций; не уезжает с вкладками -->
   <button class="search-button" type="button" *ngIf="menuSearch.available$ | async"
        (click)="menuSearch.open(); $event.stopPropagation()" aria-label="search">
     <span class="search-button__icon">
       <svg viewBox="0 0 24 24" aria-hidden="true">
         <circle cx="11" cy="11" r="6.5"></circle>
         <path d="M16 16l4.5 4.5"></path>
       </svg>
     </span>
   </button>
   <div *ngFor="let category of sortedCategories"
        class="category-item" 
        (click)="scrollToCategory(category.id); $event.stopPropagation()"
        [class.active]="currentCategoryId === category.id"
        [attr.data-id]="category.id">
     {{ category | titleTranslate }}
   </div>
 </div>